import { connect } from "react-redux";
import InvoiceRegistry from "./InvoiceRegistry";
import {
  invoiceRegistry,
  invoiceRegistriesLoading,
  invoiceRegistryLoading,
  invoiceRegistryPagination,
  getError,
} from "../../store/selectors/invoiceRegistry.selector";

const mapStateToProps = (state) => {
  const allInvoiceRegistries = invoiceRegistry(state);
  const pageLoading = invoiceRegistriesLoading(state);
  const loading = invoiceRegistryLoading(state);
  const pagination = invoiceRegistryPagination(state);
  const error = getError(state);
  return { error, allInvoiceRegistries, pagination, loading, pageLoading };
};

export default connect(mapStateToProps, null)(InvoiceRegistry);
